import { Configuration, UserAccessApi } from '../generated/clients/index.js';
/**
 * Ask auth-service whether the current cookie-authenticated user has access to
 * `brandId`, via the `my-access` endpoint.
 *
 * This is a lightweight, single-request alternative to constructing a full
 * {@link Authorizer} when a caller only needs a yes/no access answer for a
 * brand the user is not currently scoped to (e.g. a client-side route guard
 * validating a deep link). It does not build a permission tree or touch any
 * shared authorizer state.
 *
 * Auth-service (cookie) sessions only — there is no equivalent endpoint for the
 * legacy Olympus session provider.
 * @param config - Auth-service URL, target brandId, and a CSRF token reader
 */
export async function fetchMyBrandAccess(config) {
    const csrfMiddleware = {
        pre: async ({ url, init }) => {
            const csrfToken = config.getCsrfToken();
            if (!csrfToken)
                return { url, init };
            const headers = new Headers(init.headers);
            headers.set('X-CSRFToken', csrfToken);
            return { url, init: { ...init, headers } };
        },
    };
    const userAccessApi = new UserAccessApi(new Configuration({
        basePath: config.authServiceUrl,
        credentials: 'include',
        middleware: [csrfMiddleware],
    }));
    const { hasAccess, locationIds } = await userAccessApi.getMyAccess(config.brandId);
    return { hasAccess, locationIds };
}
//# sourceMappingURL=fetch-brand-access.js.map